/**
 * Shipments CopilotKit Actions
 */

import { useCopilotAction } from '@copilotkit/react-core'
import { useDispatch } from '@spcc/core'
import { shipmentsActions } from '../store/shipments.slice'

export function useShipmentsActions() {
  const dispatch = useDispatch()

  useCopilotAction({
    name: 'filterShipmentsByStatus',
    description: 'Filter shipments by status',
    parameters: [{ name: 'status', type: 'string', description: 'Status: scheduled, loading, delivered, or all', required: true }],
    handler: async ({ status }) => {
      dispatch(shipmentsActions.filterByStatus(status as 'scheduled' | 'loading' | 'delivered' | 'all'))
      return `Filtered shipments to show ${status}`
    },
  })

  useCopilotAction({
    name: 'searchShipments',
    description: 'Search shipments',
    parameters: [{ name: 'query', type: 'string', description: 'Search query', required: true }],
    handler: async ({ query }) => {
      dispatch(shipmentsActions.searchShipments(query))
      return `Searching shipments for "${query}"`
    },
  })
}
